/**
 * Rampver Account redesign (Direction C) — design tokens.
 * Mirrors design-baseline/design_handoff_account_redesign/colors_and_type.css and
 * the handoff README "Design Tokens" section. Colours only; the global theme
 * (src/index.js) and App.css supply the "Gill Sans, Poppins" font stack, so
 * components intentionally do NOT set font-family.
 */
export const T = {
  green: "#256141",
  greenDeep: "#134735",
  greenRingInner: "#173E2C",
  gold: "#C8932A",
  goldLight: "#F4DEAE",

  contentBg: "#F6F8F7",
  mint: "#F1F8F4",
  mint2: "#EAF3EE",
  hairline: "#E5E2DC",
  hairline2: "#ECEAE4",
  hairline3: "#F0EEE8",

  heading: "#171D25",
  body: "#1A2027",
  muted: "#737373",
  muted2: "#8A8A8A",
  muted3: "#9A9A9A",
} as const;

/** Status chip / banner tones (README "Status"). */
export const TONE = {
  pending: { fg: "#A87819", bg: "#FBF3E2", bd: "#EAD9AE" },
  verified: { fg: "#1A7A4E", bg: "#E6F4EC", bd: "#BFE6CE" },
  action: { fg: "#9A6A12", bg: "#FDF3E7", bd: "#F1D8AE" },
  info: { fg: "#1A4A30", sub: "#4A6A57", bg: "#EAF3EE", bd: "#D6EADD", ic: "#256141" },
} as const;

export const cardShadow = "0 8px 30px rgba(0,0,0,.05)";
export const panelShadow = "0 16px 44px rgba(19,71,53,.3)";
